import { render, staticRenderFns } from "./CattleDeviceForm.vue?vue&type=template&id=3162a2a7&scoped=true"
import script from "./CattleDeviceForm.vue?vue&type=script&lang=js"
export * from "./CattleDeviceForm.vue?vue&type=script&lang=js"
import style0 from "./CattleDeviceForm.vue?vue&type=style&index=0&id=3162a2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162a2a7",
  null
  
)

export default component.exports